/**
 * Настройки оверлея и адрес подключения.
 *
 * Всё приходит через строку запроса, потому что другого способа нет:
 * Browser Source в OBS открывает адрес и не позволяет ни задать
 * заголовки, ни передать что-либо иначе (docs/06).
 */

export interface Settings {
  /** Токен оверлея. Пустая строка означает, что оверлей не настроен. */
  readonly token: string;
  /** Адрес WebSocket-эндпоинта hub. */
  readonly hub: string;
}

/** Куда подключаться, если в адресе ничего не указано. */
const DEFAULT_HUB = 'ws://localhost:8081/ws';

export function readSettings(href: string): Settings {
  const params = new URL(href).searchParams;

  return {
    token: params.get('token') ?? '',
    hub: params.get('hub') ?? DEFAULT_HUB,
  };
}

/**
 * Собирает адрес сокета.
 *
 * Токен добавляется через searchParams, а не склейкой строк:
 * символы вроде & или # разрезали бы его пополам, и отказ
 * в подключении выглядел бы как испорченный токен.
 */
export function socketURL(hub: string, token: string): string {
  const url = new URL(hub);
  url.searchParams.set('token', token);
  return url.toString();
}
